import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import cookie from 'js-cookie';
import { Provider as NextAuthProvider } from 'next-auth/client';
import Error from 'next/error';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Script from 'next/script';
import React, { useEffect } from 'react';
import ReactDOMServer from 'react-dom/server';
import { connect } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BugSnagErrorBoundary from '../src/components/ErrorHandling/BugSnagErrorBoundary';
import FeedbackHandler from '../src/containers/FeedbackHandler';
import { ModalProvider } from '../src/contexts/ModalContext';
import { SignupProvider } from '../src/hooks/useSignupProvider';
import { wrapper } from '../src/state';
import { getLoggedInUser as getLoggedInUserAction, getTooltips as getTooltipsAction, initialLoadComplete as initialLoadCompleteAction } from '../src/state/actions';
import { CookieName } from '../src/utils/constants';
import { useHubspot } from '../src/utils/hubspot';
import '../styles/app.scss';
import '../styles/basscss.css';
import '../styles/global-tailwind.css';
import '../styles/toast.css';
import '../styles/tooltip.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var production = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'; // react can't do noscript children with content see the following:
//   - https://github.com/facebook/react/issues/7607
//   - https://github.com/facebook/react/issues/1252
// also, somewhat unrelated but affects this snippet:
//   - 15.4.{1,2} will throw an "Invariant Violation" WARNING (won't cause problems)
//     when using ReactDOM and ReactDOMServer
//     see: https://github.com/facebook/react/issues/8487 (hence using 15.5.0)

var Noscript = function Noscript(props) {
  var staticMarkup = ReactDOMServer.renderToStaticMarkup(props.children);
  return /*#__PURE__*/_jsx("noscript", {
    dangerouslySetInnerHTML: {
      __html: staticMarkup
    }
  });
};

var WrappedApp = function WrappedApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps,
      currentUser = _ref.currentUser,
      redirectTo = _ref.redirectTo,
      getLoggedInUser = _ref.getLoggedInUser,
      initialLoadComplete = _ref.initialLoadComplete,
      getTooltips = _ref.getTooltips;
  var router = useRouter();
  var accessToken = cookie.get(CookieName.ACCESS_TOKEN);
  var refreshToken = cookie.get(CookieName.REFRESH_TOKEN);

  var _useHubspot = useHubspot(),
      onLoadHubspot = _useHubspot.onLoad;

  useEffect(function () {
    if (!currentUser && (accessToken || refreshToken)) {
      getLoggedInUser();
    } else {
      initialLoadComplete();
    }

    getTooltips();
  }, []);
  useEffect(function () {
    if (redirectTo) {
      router.push(redirectTo);
    }
  }, [redirectTo]);
  return /*#__PURE__*/_jsx(ModalProvider, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "h-fill font-sans relative",
      children: [/*#__PURE__*/_jsx(ToastContainer, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        newestOnTop: true
      }), /*#__PURE__*/_jsxs(BugSnagErrorBoundary, {
        children: [/*#__PURE__*/_jsxs(Head, {
          children: [/*#__PURE__*/_jsx("title", {
            children: "Subkit"
          }), /*#__PURE__*/_jsx("meta", {
            name: "viewport",
            content: "width=device-width, height=device-height, initial-scale=1"
          }), production ? /*#__PURE__*/_jsx("script", {
            dangerouslySetInnerHTML: {
              __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','GTM-MM4M5HW');"
            }
          }) : null, /*#__PURE__*/_jsx("link", {
            rel: "icon",
            href: "https://subkit-images.s3.amazonaws.com/subkit-logos-images/favicon.ico"
          })]
        }), /*#__PURE__*/_jsx(Script, {
          src: "https://kit.fontawesome.com/418771db76.js",
          crossOrigin: "anonymous"
        }), /*#__PURE__*/_jsx(Noscript, {
          children: /*#__PURE__*/_jsx("iframe", {
            src: "https://www.googletagmanager.com/ns.html?id=GTM-MM4M5HW",
            height: "0",
            width: "0",
            style: {
              display: 'none',
              visibility: 'hidden'
            }
          })
        }), /*#__PURE__*/_jsx(FeedbackHandler, _objectSpread(_objectSpread({}, pageProps), {}, {
          children: pageProps.pageServerSideError ? /*#__PURE__*/_jsx(Error, {
            statusCode: pageProps.pageServerSideError.statusCode
          }) : /*#__PURE__*/_jsx(SignupProvider, {
            children: /*#__PURE__*/_jsx(NextAuthProvider, {
              session: pageProps.session,
              children: /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps))
            })
          })
        }))]
      }), production ? /*#__PURE__*/_jsx("script", {
        dangerouslySetInnerHTML: {
          __html: "window.axeptioSettings = {\n                clientId: \"600edd3d7a514b3c6ea0b1d5\",\n                cookiesVersion: \"subkit-base\",\n              };\n\n              (function(d, s) {\n                var t = d.getElementsByTagName(s)[0], e = d.createElement(s);\n                e.async = true; e.src = \"//static.axept.io/sdk.js\";\n                t.parentNode.insertBefore(e, t);\n              })(document, \"script\");\n              "
        }
      }) : null, production ? null : /*#__PURE__*/_jsx("script", {
        dangerouslySetInnerHTML: {
          __html: "!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error(\"Segment snippet included twice.\");else{analytics.invoked=!0;analytics.methods=[\"trackSubmit\",\"trackClick\",\"trackLink\",\"trackForm\",\"pageview\",\"identify\",\"reset\",\"group\",\"track\",\"ready\",\"alias\",\"debug\",\"page\",\"once\",\"off\",\"on\",\"addSourceMiddleware\",\"addIntegrationMiddleware\",\"setAnonymousId\",\"addDestinationMiddleware\"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement(\"script\");t.type=\"text/javascript\";t.async=!0;t.src=\"https://cdn.segment.com/analytics.js/v1/\" + key + \"/analytics.min.js\";var n=document.getElementsByTagName(\"script\")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey=\"B1AxEcHaElC5PY9gSeYlGtB7RcZbXSkp\";analytics.SNIPPET_VERSION=\"4.13.2\";\n  analytics.load(\"B1AxEcHaElC5PY9gSeYlGtB7RcZbXSkp\");\n  analytics.page();\n  }}();\n              "
        }
      }), production ? /*#__PURE__*/_jsx(Script, {
        src: "//js.hs-scripts.com/19575727.js",
        strategy: "lazyOnload",
        onLoad: onLoadHubspot
      }) : null]
    })
  });
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$auth, _state$auth$users, _state$redirect, _state$copy;

  return {
    currentUser: state === null || state === void 0 ? void 0 : (_state$auth = state.auth) === null || _state$auth === void 0 ? void 0 : (_state$auth$users = _state$auth.users) === null || _state$auth$users === void 0 ? void 0 : _state$auth$users.current,
    redirectTo: state === null || state === void 0 ? void 0 : (_state$redirect = state.redirect) === null || _state$redirect === void 0 ? void 0 : _state$redirect.to,
    tooltips: (_state$copy = state.copy) === null || _state$copy === void 0 ? void 0 : _state$copy.tooltips
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getLoggedInUser: function getLoggedInUser() {
      return dispatch(getLoggedInUserAction());
    },
    initialLoadComplete: function initialLoadComplete() {
      return dispatch(initialLoadCompleteAction());
    },
    getTooltips: function getTooltips() {
      return dispatch(getTooltipsAction());
    }
  };
};

export default wrapper.withRedux(connect(mapStateToProps, mapDispatchToProps)(WrappedApp));